import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("Check your inbox for a reset link");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-6 py-16">
      <div className="overline text-safety">Forgot password</div>
      <h1 className="mt-2 font-display font-black text-4xl tracking-tighter text-forest">Reset your password</h1>

      {sent ? (
        <div className="mt-8 border border-forest bg-sage-light p-8 flex items-start gap-4">
          <Mail className="w-6 h-6 text-forest shrink-0" />
          <div>
            <div className="font-display text-lg tracking-tight text-forest">Check your inbox</div>
            <p className="mt-2 text-sm text-muted-foreground">
              If an account exists for <b>{email}</b>, we've sent a password-reset link. It expires in 1 hour.
            </p>
            <p className="mt-2 text-xs text-muted-foreground">
              Sent from <span className="font-mono">admin@furnitureexchange.co.uk</span> — check spam if you can't see it.
            </p>
          </div>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 border border-border bg-white p-8 space-y-5">
          <div>
            <div className="overline text-muted-foreground mb-2">Email</div>
            <Input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="forgot-email"
              className="rounded-none h-12"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="forgot-submit"
            className="w-full rounded-none bg-forest hover:bg-forest-800 text-white h-12"
          >
            {loading ? "Sending…" : "Send reset link"}
          </Button>
          <div className="text-xs text-muted-foreground">
            We'll email you a link to reset your password. It expires in 1 hour.
          </div>
        </form>
      )}

      <div className="mt-6 text-sm text-center">
        <Link to="/login" className="text-forest hover:text-safety">← Back to log in</Link>
      </div>
    </div>
  );
}
